import React from 'react'
import { Outlet } from 'react-router-dom'
import HeaderComponent from '../layout/HeaderComponent'
import CartDrawer from '../cart/CartDrawer'
export default function Layout() {
  return (
   <>
            <HeaderComponent />
            <CartDrawer />
            <Outlet/>

   </>
  )
}
